export const logDevtoolsGreeting = () => {
  try {
    const big =
      "font-size:18px;font-weight:bold;color:#527FBE;font-family:Georgia,serif";
    const body = "font-size:13px;color:#2D1B36;line-height:1.6";
    const code = "font-size:13px;color:#16a34a;font-weight:bold";
    const wink = "font-size:11px;color:#888;font-style:italic";

    console.log("%c👋 Hello, fellow nerd.", big);
    console.log(
      "%cIf you're poking around our code, you'll probably enjoy our courses.",
      body,
    );
    console.log(
      "%cUse the code DEVTOOLS at checkout for 15%" + " off any single course.",
      code,
    );
    console.log(
      "%cWe see you. We respect you. Stop minifying our jokes.",
      wink,
    );
  } catch (e) {
    // noop
  }
};
